import FS_HOME_ACERCA_IMAGEN from "../../../assets/img/FS-HOME-ACERCA-IMAGEN.png";
import RegularInfBox from "../../Molecules/RegularInfBox/RegularInfBox";
import "./HomeAboutForesightSection.scss";
import content from "../../Pages/Home/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

function HomeAboutForesight() {
	const {language} = useLanguageCtx();

	return (
		<div className="max-width home-about-foresight-container top-space-section home">
			<img
				src={FS_HOME_ACERCA_IMAGEN}
				alt="FS_HOME_ACERCA_IMAGEN"
			/>
			<div className="box-container">
				<RegularInfBox
					yellowTitle={content[language].acercaYellowTitle}
					boldTitle={content[language].acercaBoldText}
					content={content[language].acercaText}
					buttonRoute="/acerca"
					buttonType="button light-blue outline"
					buttonContent={content[language].acercaButtonContent}
				/>
			</div>
		</div>
	);
}

export default HomeAboutForesight;
